<template>
  <v-card-text
    :style="[{'background-color': distributor.distributorCode1 === detailedDistributor.distributorCode1 ? '#eee' : ( isHovered ? '#eee' : 'initial')}]"
    @click="showLogsDetails(distributor)" 
    @mouseover="isHovered = true"
    @mouseout="isHovered = false"
    style="cursor:default;"
  >
    <v-layout wrap align-center>
      <v-flex xs12 sm5 md5>
        <span class="pl-2 d-block" style="text-transform:capitalize !important;font-size:13px;font-weight:bold;">
          {{ distributor.distributorName.toLowerCase() }}
        </span>
      </v-flex>
      <v-flex xs12 sm7 md7>
        <distributor-details-indicators-list
          :indicators="indicators"
          :distributor="distributor"
        ></distributor-details-indicators-list>
      </v-flex>
    </v-layout>
  </v-card-text>
</template>

<script>
import cardsStorage from '../../storage/cardsStorage'

import DistributorDetailsIndicatorsList from './distributor-details-indicators-list'

export default {
  data () {
    return {
      cards: [],
      isHovered: false
    }
  },
  mounted () {
    this.cards = cardsStorage.getCardsPointer().cards
  },
  computed: {},
  methods: {},
  components: {
    DistributorDetailsIndicatorsList
  },
  props: {
    distributor: {
      type: Object,
      default () {
        return {}
      }
    },
    detailedDistributor: {
      type: Object,
      default () {
        return {}
      }
    },
    showLogsDetails: {
      type: Function,
      default () {
        return () => {}
      }
    },
    indicators: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/supervisor/distributor-detail-section.vue